import { FormDataModel } from '@/model/FormModel'
import { payTypeList } from '@/utils/index'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '客户公司',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'mainBusiness',
        fieldName: '主营业务',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'website',
        fieldName: '企业网站',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'fax',
        fieldName: '公司传真',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'phone',
        fieldName: '公司座机',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'email',
        fieldName: '企业邮箱',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-cascader-provinces',
        componentName: '省市区级联',
        fieldKey: 'address',
        fieldName: '省市县',
        placeholder: '',
        value: [],
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          isDisabled: false,
          multiple: true,
          clearable: true,
          filterable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'addressDetail',
        fieldName: '详细地址',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'customerLevelId',
        fieldName: '客户级别',
        placeholder: '',
        value: null,
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'customerLevel/dropdown',
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'customerSourceId',
        fieldName: '客户来源',
        placeholder: '',
        value: null,
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'customerSource/dropdown',
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'paymentCycleId',
        fieldName: '付款周期',
        placeholder: '',
        value: null,
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'paymentCycle/dropdown',
          pickerType: '',
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'industryId',
        fieldName: '所属行业',
        placeholder: '',
        value: null,
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'industry/dropdown',
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'companyTypeId',
        fieldName: '公司类型',
        placeholder: '',
        value: null,
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'companyType/dropdown',
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'overdueDaysWithoutBusiness',
        fieldName: '超期未合作天数',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'overdueDaysWithoutOrder',
        fieldName: '超期未订单天数',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'overdueDaysWithoutContact',
        fieldName: '超期未联系天数',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'overdueDaysWithoutPayment',
        fieldName: '超期未收款天数',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'salesManId',
        fieldName: '业务员',
        placeholder: '',
        value: null,
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'user/dropdown/salesman',
          pickerType: '',
          filterable: true,
          selectType: 2, // 1本地2远程
          label: 'mark'
        }
      }, {
        componentType: 'el-textarea',
        componentName: '输入框',
        fieldKey: 'mark',
        fieldName: '备注信息',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false,
          width: '100%'
        }
      }
    ]
  }, {
    title: '联系人信息',
    type: 2,
    labelClass: 'yellow',
    labelName: '联',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'contacts',
        fieldName: '渲染列表',
        config: {},
        id: 0,
        list: [
          {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'name',
            fieldName: '姓名',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-select',
            componentName: '下拉选择',
            fieldKey: 'sex',
            fieldName: '性别',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
            option: [],
            config: {
              collapseTags: true,
              isDisabled: false,
              multiple: false,
              clearable: true,
              url: 'Sex',
              pickerType: '',
              filterable: true,
              selectType: 1// 1本地2远程
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'email',
            fieldName: '邮箱',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'wechat',
            fieldName: '微信',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'qq',
            fieldName: 'QQ',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'phone',
            fieldName: '联系电话',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'post',
            fieldName: '岗位',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'dept',
            fieldName: '部门',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-date-picker',
            componentName: '日期选择',
            fieldKey: 'birthday',
            fieldName: '生日',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '', trigger: 'change' }],
            option: [],
            config: {
              isDisabled: false,
              clearable: true,
              type: 'date',
              format: 'YYYY-MM-DD',
              valueFormat: 'YYYY-MM-DD'
            }
          }, {
            componentType: 'el-cascader-provinces',
            componentName: '省市区级联',
            fieldKey: 'address',
            fieldName: '省市县',
            placeholder: '',
            value: [],
            rules: [{ required: false, message: '', trigger: 'change' }],
            option: [],
            config: {
              isDisabled: false,
              multiple: true,
              clearable: true,
              filterable: true
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'addressDetail',
            fieldName: '详细地址',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'mark',
            fieldName: '备注',
            placeholder: '',
            value: '',
            rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          },
          {
            componentType: 'el-select',
            componentName: '下拉选择',
            fieldKey: 'type',
            fieldName: '支付类型',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            option: payTypeList,
            config: {
              isDisabled: false,
              multiple: false,
              clearable: true,
              selectType: 3, // 1本地2远程
              uniqueFieldKey: 'companyPayType',
              submitField: 'accounts'
            }
          },
          {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'accountName',
            fieldName: '公司全称/账户名',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false,
              isHide: true,
              submitField: 'accounts'
            }
          },
          {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'no',
            fieldName: '银行账号',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false,
              isHide: true,
              submitField: 'accounts'
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'bank',
            fieldName: '开户行',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false,
              isHide: true,
              submitField: 'accounts'
            }
          }
          // {
          //   componentType: 'el-input',
          //   componentName: '输入框',
          //   fieldKey: 'bankNo',
          //   fieldName: '行号',
          //   placeholder: '',
          //   value: '',
          //   rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
          //   config: {
          //     isDisabled: false,
          //     clearable: true,
          //     url: '',
          //     filterable: false,
          //     submitField: 'accounts'
          //   }
          // }
        ]
      }
    ]
  }, {
    title: '开票信息',
    type: 2,
    labelClass: 'green',
    labelName: '开',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'tickets',
        fieldName: '渲染列表',
        config: {},
        id: 0,
        list: [
          {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'titleName',
            fieldName: '公司抬头',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'taxId',
            fieldName: '税号',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'registeredAddress',
            fieldName: '注册地址',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'bank',
            fieldName: '开户银行',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'account',
            fieldName: '银行账号',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }, {
            componentType: 'el-input',
            componentName: '输入框',
            fieldKey: 'phone',
            fieldName: '电话号码',
            placeholder: '',
            value: '',
            rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
            config: {
              isDisabled: false,
              clearable: true,
              url: '',
              filterable: false
            }
          }
        ]
      }
    ]
  }
]
